import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import DatePicker from '../../../common/forms/input/DatePicker';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

export const BillReportSearchForm = ({ handleSubmit }) => {
  const formProps = { onSubmit: handleSubmit };

  return (
    <Form {...formProps}>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired, validateDate]}
          />
        </FormItem>
      </FormGroup>

      <Row>
        <Col className="flex row-reverse">
          <FormFooter
            saveButtonText="Buscar"
            saveButtonIcon="fa fa-search"
            saveButtonColor="secondary"
          />
        </Col>
      </Row>
    </Form>
  );
};

BillReportSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'BillReportSearchForm',
})(BillReportSearchForm);
